<template>
  <div class="user-menu">
    <div class="user-menu-toggle d-flex align-items-center" @click="toggleMenu">
      <Avatar
        class="layout-topbar-action"
        :image="authStore.user.avatar || defaultAvatar"
        size="large"
        shape="circle"
        aria-haspopup="true"
        aria-controls="userOverlayMenu"
        style="border: 2px solid var(--primary-color)"
      />
      <i class="pi pi-chevron-down ms-1" style="font-size: 0.7rem" />
    </div>
    <Menu
      id="userOverlayMenu"
      ref="userMenu"
      class="user-menu-dropdown"
      :model="menuItems"
      popup
    >
      <template #start>
        <div class="d-flex w-full p-3 pb-2">
          <Avatar
            :image="authStore.user.avatar || defaultAvatar"
            class="me-2"
            size="large"
            shape="circle"
            style="border: 2px solid var(--primary-color)"
          />
          <span class="d-inline-flex flex-column align-items-start">
            <span class="fw-bold">{{ authStore.user.name }}</span>
            <span class="user-role">{{ authStore.user.role }}</span>
          </span>
        </div>
        <div class="p-2 d-lg-none">
          <HubSelector />
        </div>
      </template>
      <template #submenulabel="{ item }">
        <span class="fw-bold">{{ item.label }}</span>
      </template>
      <template #item="{ item, props }">
        <router-link
          v-if="item.route"
          :to="item.route"
          class="d-flex align-items-center"
          v-bind="props.action"
        >
          <span :class="item.icon" />
          <span>{{ item.label }}</span>
        </router-link>
        <a v-else class="d-flex align-items-center" v-bind="props.action">
          <span :class="item.icon" />
          <span>{{ item.label }}</span>
        </a>
      </template>
    </Menu>
  </div>
</template>

<script setup>
import { computed, useTemplateRef } from "vue"
import { useAuthenticationStore } from "@/store"
import { useDialog } from "primevue/usedialog"
import { useI18n } from "vue-i18n"
import AppInfo from "@/components/misc/AppInfo.vue"
import HubSelector from "@/components/misc/HubSelector.vue"

const authStore = useAuthenticationStore()
const dialog = useDialog()
const { t } = useI18n()

const defaultAvatar = "/assets/images/avatar.webp"

const menuItems = computed(() => [
  {
    separator: true
  },
  {
    label: t("userMenu.general.title"),
    items: [
      {
        label: t("userMenu.general.accounts"),
        icon: "pi pi-building",
        route: "/accounts"
      },
      {
        label: t("userMenu.general.settings"),
        icon: "pi pi-cog",
        route: "/settings"
      },
      {
        label: t("userMenu.general.appInfo"),
        icon: "pi pi-info-circle",
        command: () => appInfo()
      },
      {
        label: t("userMenu.general.logout"),
        icon: "pi pi-sign-out",
        command: () => authStore.logout()
      }
    ]
  }
])

const userMenu = useTemplateRef("userMenu")

const toggleMenu = (event) => {
  userMenu.value.toggle(event)
}

const appInfo = () => {
  dialog.open(AppInfo, {
    props: {
      header: t("global.appInfo.title"),
      modal: true,
      dismissableMask: true
    }
  })
}
</script>
